<div class="not-found">
    <img class="image" src="/assets/icons/notfound.png" alt="Not Found">
    <p class="header">Page Not Found</p>
    <button class="btn" (click)="goToHome()">
        <span>Go to Hey-Kiddo Home</span>
    </button>
</div>